const Loader = () => {
  return (
    <div className="loader-wrapper">
      <img
        className="ajax-loader-1"
        src="https://www.worldbank.org/content/dam/wbr-redesign/logos/ajax.gif"
        alt="loader"
      />
    </div>
  )
}

export default Loader
